module.exports = __webpack_public_path__ + "media/images/client-2-alt-0b5f871efe2791fafca104640af3672a.png";